import { Controller } from '@hotwired/stimulus'
import { LeafletConfig } from 'config.js'
import L from 'leaflet'
import 'leaflet.markercluster'

export default class extends Controller {
  static values = { markers: Array }

  connect() {
    const mapNode = document.getElementById('map')
    const markersList = JSON.parse(mapNode.dataset.markers) || []
    this.#renderClusteredMap(markersList, this.#popoverRenderer)
  }
  #renderClusteredMap(markersList, popupRenderer) {
    const mapNode = document.getElementById('map')
    if (!mapNode) return

    const map = L.map(mapNode, { scrollWheelZoom: false })
    L.tileLayer('https://maps.nouslib.com/osm/{z}/{x}/{y}.png').addTo(map)

    const icon = L.icon({
      iconUrl: LeafletConfig.markerIconUrl,
      iconSize: [54, 72],
      iconAnchor: [27, 72]
    })

    const markers = L.markerClusterGroup({
      showCoverageOnHover: false,
      iconCreateFunction: (cluster) => L.divIcon({
        html: `<b>${cluster.getChildCount()}</b>`,
        className: 'map-cluster map-cluster--small'
      })
    })

    let bounds = L.latLngBounds()
    let addedMarkers = false

    markersList.forEach(m => {
      if (m.lat && m.lng) {
        const marker = L.marker(new L.LatLng(m.lat, m.lng), { title: m.name, icon: icon })
        marker.bindPopup(popupRenderer(m))
        markers.addLayer(marker)
        bounds.extend(marker.getLatLng())
        addedMarkers = true
      }
    })

    if (!addedMarkers) {
      const defaultMarker = L.marker([48.8566, 2.3522], { icon: icon })
      defaultMarker.bindPopup(I18n.t('js.common.no_result'))
      markers.addLayer(defaultMarker)
      bounds.extend(defaultMarker.getLatLng())
    }

    map.addLayer(markers)
    map.fitBounds(bounds, { paddingTopLeft: [30, 50], paddingBottomRight: [30, 50] })
  }

  #popoverRenderer(marker) {
    return `
    <div class="map-popup__content">
      <div class="map-popup__title">${marker.name}</div>
      ${marker.date ? `<div class="map-popup__subtitle">${marker.date}</div>` : ''}
      <div class="map-popup__text">
        ${marker.address}<br>
        ${marker.zip} ${marker.city} (${marker.country})<br>
        Tel : ${marker.phone}
      </div>
      <div class="map-popup__cta">
        <a href="${marker.url}" class="button-solid-brand">
          ${I18n.t('js.common.see_more')}
        </a>
      </div>
    </div>
  `
  }
}